module.exports = __webpack_public_path__ + "img/TOTAL.3dd11de2.svg";